class HeaderDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'click',
      ({ target }) => {
        if (target.matches('.js-button-parent')) {
          this.toggle(target, 'parent');
          console.log(target);
        }

        if (target.matches('.js-button-child')) {
          this.toggle(target, 'child');
        }

        if (target.matches('.js-button-grandchild')) {
          console.log(target);
          this.close(target, 'grandchild');
        }
      },
      false
    );
  }

  toggle($button, from = 'parent') {
    if ($button.getAttribute('aria-expanded') === 'false') {
      return this.open($button, from);
    }

    return this.close($button, from);
  }

  open(target, from = 'parent') {
    // console.log('HeaderDrawer.open');

    this.header = this.header || document.querySelector('.section-header');

    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${this.header.getBoundingClientRect().bottom}px`
    );

    window.addEventListener('resize', this.onResize);

    if (from === 'child') {
      this.querySelectorAll('[id^="links-child"]').forEach(($panel) => $panel.setAttribute('aria-expanded', 'false'));
      this.querySelectorAll('[aria-controls^="links-child"]').forEach(($panel) =>
        $panel.setAttribute('aria-expanded', 'false')
      );
    }

    target.setAttribute('aria-expanded', 'true');

    const ids = target.getAttribute('aria-controls').trim().split(' ');

    ids.forEach((id) => {
      const element = this.querySelector(`#${id}`);

      element.setAttribute('aria-expanded', 'true');
    });

    if (from === 'parent') {
      this.querySelectorAll('[aria-controls^="links"]').forEach(($button) => {
        ids.forEach((id) => {
          if ($button.getAttribute('aria-controls').includes(id) && $button !== target) {
            $button.setAttribute('aria-expanded', 'true');
          }
        });
      });
    }

    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add('menu-openned');
  }

  close(target, from = 'parent') {
    // console.log('HeaderDrawer.close');

    target.setAttribute('aria-expanded', 'false');

    const ids = target.getAttribute('aria-controls').trim().split(' ');

    console.log(ids);

    ids.forEach((id) => {
      const $element = this.querySelector(`#${id}`);

      if ($element) {
        $element.setAttribute('aria-expanded', 'false');
      }
    });

    if (from === 'parent') {
      this.querySelectorAll('[aria-controls^="links"]').forEach(($button) => {
        $button.setAttribute('aria-expanded', 'false');
      });
      this.querySelectorAll('[id^="links"]').forEach(($panel) => {
        $panel.setAttribute('aria-expanded', 'false');
      });
    }

    if (from === 'grandchild') {
      this.querySelectorAll('[aria-controls^="links-child"]').forEach(($button) => {
        $button.setAttribute('aria-expanded', 'false');
      });
    }

    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.remove('menu-openned');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${this.header.getBoundingClientRect().bottom}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);
